import Component0 from './plugins/Component0/Home';
import Component8 from './plugins/Component8/App';

const components = {
    Component0,
    Component8
};

export default components;